import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage/storage.service';

export const authGuard: CanActivateFn = (route, segments) => {
  let storageService = inject(StorageService);
  let router = inject(Router);
  let token = storageService.hasToken();
  if (token) {
    router.navigate(['/s']);
    return false;
  } else {
    return true;
  }
};
